import { useState, useEffect } from 'react'




function Footer(props) {


    return (
        <div className="hidden xl:block w-full h-[100px] px-[200px]" >
           
            <div className='flex flex-col float-start w-[calc(100%-100px)]'>
                <div className='w-full h-[50px] border-b border-gray-200'></div>
                <div className='flex items-center w-full h-[50px] text-gray-500 text-[12px]'>
                    Copyright © 2025 23rd Studio. All rights reserved.
                </div>
            </div>

            <div className='flex justify-start items-center w-[100px] float-end h-[100px] '>
                <img
                    src="/assets/img/23rd.png"
                    alt="Robot"
                    className="max-h-full max-w-full object-contain"
                />
            </div>


        </div>
    )

}

export default Footer;